export const DefaultCurrency = 'USD'
export const isPre = import.meta.env.VITE_RUN_ENV === 'pre'
export const isTest = import.meta.env.VITE_RUN_ENV === 'test'
export const isRelease = import.meta.env.VITE_RUN_ENV === 'release'

export const isDev = import.meta.env.VITE_RUN_ENV === 'dev'

// 站点构建器 GCS 桶名，根据运行环境切换：dev/test 走 test 桶，pre/release 走 live 桶。
export const SiteBuilderBucket = isTest || isDev ? 'rivergame-site-builder-test' : 'rivergame-site-builder-live'

export const baseDomain = 'rivergame.net'


export const envTitle = isPre ? '预发布' : isTest ? '测试' : isDev ? '开发' : ''

export const PlaceholderId = ':projectId'